import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconPackageAdd: React.FC<CentralIconBaseProps> = (props) => {
  return (
    <CentralIconBase {...props} ariaLabel="package-add,delivery">
      <path
        d="M4 4V3H3V4H4ZM4 20H3V21H4V20ZM20 4H21V3H20V4ZM10 4V3H8V4H10ZM9 9H8V10H9V9ZM15 9V10H16V9H15ZM16 4V3H14V4H16ZM19 14V13H17V14H19ZM17 20V21H19V20H17ZM15 16H14V18H15V16ZM21 18H22V16H21V18ZM3 4V20H5V4H3ZM4 21H12V19H4V21ZM4 5H20V3H4V5ZM19 4V11H21V4H19ZM8 4V9H10V4H8ZM9 10H15V8H9V10ZM16 9V4H14V9H16ZM17 14V17H19V14H17ZM17 17V20H19V17H17ZM15 18H18V16H15V18ZM18 18H21V16H18V18Z"
        fill="currentColor"
      />
    </CentralIconBase>
  );
};

export default IconPackageAdd;
